module.exports = __webpack_public_path__ + "img/digitalguru.7c9fd432.svg";